//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PortalFileUpload from "@/pcpage/hr/recruitment/portal/component/PortalFileUpload";
import { rec } from "@/lang/zh";
import NoDataDisplay from "@/pccomponents/NoDataDisplay";
import ffapplydept from "@/pccomponents/ffapplydept";
import SelectHrBankListInfo from "@/pccomponents/SelectHrBankListInfo"
export default {
  components: {
    PortalFileUpload,
    NoDataDisplay,
    ffapplydept,
    SelectHrBankListInfo,
  },
  props: {
    width: {
      type: String,
      default: "50%",
    },
  },
  data() {
    return {
      dialogVisible: false,
      record: {},
      idTypeList: [],
      idNumberMax: {},
      relationshipList: [],
      nationalityList: [],
      phoneTypeList: [],
      addressTypeList: [],
      priorityList: [],
      accountTypeList: [],
      insourceList: [],
      religionList: [],
      marstatusList: [],
      step: '1',
      isButtonDisabled: false,
      pageinfo: {currPage: 0, rowsPerPage: 1000, count: 0},
      bankData: [],
      bankListData: [],
      isMobile: false,
    };
  },
  methods: {
    init(item) {
      this.dialogVisible = true;
      this.record = item;
      this.initSelect();
      this.getIdTypeList();
      this.getRelationshipList();
      // this.getBankInfo();
      let governmentList = this.record.governmentList;
      if (governmentList && governmentList.length > 0) {
        for (var i = 0; i < governmentList.length; i++) {
          let idtype = governmentList[i].idtype;
          this.changeIdType(i, idtype);
        }
      }
    },
    backForm() {
      this.step = Number(this.step) - 1;
    },
    async nextForm() {
      let value = await this.checkForm();
      if (value) {
        this.step = Number(this.step) + 1;
      }
    },
    async submitMethod() {
      let value = await this.checkForm();
      if (value) {
        let flag = await this.tipCustomConfirmNew("default", "Are you sure to submit?","").then((res) => {
          return res;
        });
        if (flag) {
          // 禁用按钮，防止重复点击
          this.isButtonDisabled = true;
          // 设置一个定时器，在60秒后重新启用按钮
          setTimeout(() => {
            this.isButtonDisabled = false;
          }, 60 * 1000);
          // 数据保存
          let url = "api/api/saveEmployeeCollection";
          let params = {
            'record': this.record
          };
          this.axios.post(url, params).then(({ data }) => {
            if (data.code == "1") {
              // 回调
              this.$emit("findOfferProcess");
              this.dialogVisible = false;
            }
          });
        }
      }
    },
    querySearch(queryString, callBackVal) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      //调用 callback 返回建议列表的数据
      callBackVal(results);
    },
    resetRem() {
      let html = document.documentElement;
      html.style.fontSize = 100 * (html.clientWidth / 750) + "px";
      // 监听 window 的 resize 事件．在浏览器窗口变化时再设置下区域高度．
      window.onresize = () => {
        let html = document.documentElement;
        html.style.fontSize = 100 * (html.clientWidth / 750) + "px";
      };
    },
    initSelect(){
      let p_nationality = {
        showcode:'nationalityList',
        selectcode:'SYS_BNATIONALITY',
        hasnull:false,
        paras:{}
      };
      let p_phoneType = {
        showcode:'phoneTypeList',
        selectcode:'SYS_CDFCODECONFIG',
        hasnull:false,
        paras:{"paras0":"EMERGENCY_PHONE_TYPE","paras1":"1"}
      };   
      let p_addressType = {
        showcode:'addressTypeList',
        selectcode:'SYS_CDFCODECONFIG',
        hasnull:false,
        paras:{"paras0":"ADDRESS_TYPE","paras1":"1"}
      };
      let p_priority = {
        showcode:'priorityList',
        selectcode:'SYS_CDFCODECONFIG',
        hasnull:false,
        paras:{"paras0":"PRIORITY","paras1":"1"}
      };
      let p_accounttype = {
        showcode:'accountTypeList',
        selectcode:'SYS_CDFCODECONFIG',
        hasnull:false,
        paras:{"paras0":"ACCOUNTTYPE","paras1":"1"}
      };
      let p_insource = {
        showcode:'insourceList',
        selectcode:'SYS_CDFCODECONFIG',
        hasnull:false,
        paras:{"paras0":"RECRUITMENT_SOURCE","paras1":"1"}
      };
      let p_religion = {
        showcode:'religionList',
        selectcode:'SYS_CDFCODECONFIG',
        hasnull:false,
        paras:{"paras0":"RELIGION","paras1":"1"}
      };
      let p_marstatus = {
        showcode:'marstatusList',
        selectcode:'SYS_CDFCODECONFIG',
        hasnull:false,
        paras:{"paras0":"MARSTATUS","paras1":"1"}
      };
      let params = [];
      params.push(p_nationality);
      params.push(p_phoneType);
      params.push(p_addressType);
      params.push(p_priority);
      params.push(p_accounttype);
      params.push(p_insource);
      params.push(p_religion);
      params.push(p_marstatus);
      this.initDropDown(this,params);
    },
    async getIdTypeList() {
      let url = "api/api/findSelectGovernmentType";
      let params = {
          
      };
      await this.axios.post(url, params).then(({ data }) => {
        if (data.code == "1") {
          this.idTypeList = data.data.record;
        }
      });
    },
    async getRelationshipList() {
      let url = "api/api/findSelectRelationship";
      let params = {
          
      };
      await this.axios.post(url, params).then(({ data }) => {
        if (data.code == "1") {
          this.relationshipList = data.data.record;
        }
      });
    },
    focusTimePicker(className) {
      this.$nextTick(() => {
          setTimeout(() => {
            document.getElementsByClassName(className)[0].style.zIndex = 9000000;
          }, 100);
      });
    },

    async getBankInfo() {
      let url = "selectPubController/getSelectPub";
      let params = {
        selectwintype: 'select-cbank-info',
        selecttype: 'radio',
        defparas: '',
        cond: '',
        sysid: 'SCM',
        pageinfo: this.pageinfo,
        pagecond: {},
        flowsysid: '',
        condclassparams: '',
        t_params: "1"
      };
      await this.axios.post(url, params).then(({ data }) => {
        if (data.code == "1") {
          this.bankData = data.data.querydata;
          this.setBankSelectData();
        }
      });
    },

    setBankSelectData() {
      let data = this.bankData;
      if (data && data.length > 0) {
        for (var i = 0; i < data.length; i++) {
            let map = {};
            map.propertyValue = data[i].bankcode;
            map.propertyLabel = data[i].bankcode + '-' + data[i].bankname;
            this.bankListData.push(map);
        }
      }
    },

    changeBank(value, index) {
      let data = this.bankData;
      if (data && data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].bankcode == value) {
            this.$set(this.record.bankList[index], "openbank",  data[i].bankname);
            this.$set(this.record.bankList[index], "bankcountry", data[i].country);
            this.$set(this.record.bankList[index], "bankcompanycode", data[i].companycode);
            this.$set(this.record.bankList[index], "banktype",  data[i].banktype);
            this.$set(this.record.bankList[index], "bankswift", data[i].bankcode);
            this.$set(this.record.bankList[index], "bankaddress", data[i].bankaddress);
          }
        }
      }
    },

    selectBankInfoBack(params) {
      let index = params.rowindex;
      if (params.returnData && params.returnData.length > 0 && this.isNotNullOrEmpty(params.returnData[0].bankcode)) {
        let data = params.returnData[0];
        this.$set(this.record.bankList[index], "openbank", data.bankname);
        this.$set(this.record.bankList[index], "bankcountry", data.country);
        this.$set(this.record.bankList[index], "bankcompanycode", data.companycode);
        this.$set(this.record.bankList[index], "banktype",  data.banktype);
        this.$set(this.record.bankList[index], "bankswift", data.bankcode);
        this.$set(this.record.bankList[index], "bankaddress", data.bankaddress);
      } else {
        this.$set(this.record.bankList[index], "openbank",  "");
        this.$set(this.record.bankList[index], "bankcountry", "");
        this.$set(this.record.bankList[index], "bankcompanycode", "");
        this.$set(this.record.bankList[index], "banktype",  "");
        this.$set(this.record.bankList[index], "bankswift", "");
        this.$set(this.record.bankList[index], "bankaddress", "");
      }
    },

    addGovernmentList() {
      let length = this.record.governmentList.length;
      this.idNumberMax[length] = 50;
      this.addrow(this.record.governmentList);
    },

    changeIdType(index, value) {
      let maxNumber = 50;
      if (value == '10000001') {
        maxNumber = 12;
      } else if (value == '10000002') {
        maxNumber = 10;
      } else if (value == '10000008') {
        maxNumber = 12;
      } else if (value == '10000003') {
        maxNumber = 12;
      }
      this.idNumberMax[index] = maxNumber;
    },

    handleInput(index, item) {
      let idtype = item.idtype;
      if (idtype == '10000001' || idtype == '10000002' || idtype == '10000008' || idtype == '10000003') {
        let value = item.idnumber;
        this.record.governmentList[index].idnumber = value.replace(/\D/g, '');
      }
    },

    async checkForm() {
      let msg = '';
      if (this.step == '1') {
        let addressList = this.record.addressList;
        if (addressList && addressList.length > 0) {
          for (var i = 0; i < addressList.length; i++) {
            let address = addressList[i];
            if (!this.isNotNullOrEmpty(address.addresstype)) {
              msg += "Address Type (Address Details " + (i + 1) + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(address.priority)) {
              msg += "Priority (Address Details " + (i + 1) + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(address.addressline)) {
              msg += "Address Line (Address Details " + (i + 1) + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(address.barangay)) {
              msg += "Barangay (Address Details " + (i + 1) + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(address.city)) {
              msg += "City (Address Details " + (i + 1) + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(address.region)) {
              msg += "Region (Address Details " + (i + 1) + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(address.country)) {
              msg += "Country (Address Details " + (i + 1) + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(address.zipcode)) {
              msg += "Zip Code (Address Details " + (i + 1) + ") is required. </br>";
            }
          }
        }
      } else if (this.step == '2') {
        let governmentList = this.record.governmentList;
        if (governmentList && governmentList.length > 0) {
          for (var i = 0; i < governmentList.length; i++) {
            let government = governmentList[i];
            if (!this.isNotNullOrEmpty(government.idtype)) {
              msg += "ID Type (Government ID Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(government.idnumber)) {
              msg += "ID Number (Government ID Details " + (i + 1) + ") is required. </br>";
            }
            if (government.idnumber && (government.idnumber == '10000004' || government.idnumber == '10000005')) {
              if (!this.isNotNullOrEmpty(government.startdate)) {
                msg += "Validity Start Date (Government ID Details " + (i + 1) + ") is required. </br>";
              }
              if (!this.isNotNullOrEmpty(government.enddate)) {
                msg += "Validity End Date (Government ID Details " + (i + 1) + ") is required. </br>";
              }
            }
            // 添加数字字数判定
            let idtype = government.idtype;
            let idnumber = government.idnumber;
            if (idtype && idnumber && (idtype == '10000001' || idtype == '10000008' || idtype == '10000003') && idnumber.length != 12) {
              msg += "ID Number (Government ID Details " + (i + 1) + ") length must equal 12. </br>";  
            } else if (idtype && idnumber && idtype == '10000002' && idnumber.length != 10) {
              msg += "ID Number (Government ID Details " + (i + 1) + ") length must equal 10. </br>";  
            }
          }
        }
      } else if (this.step == '3') {
        let familyList = this.record.familyList;
        if (familyList && familyList.length > 0) {
          for (var i = 0; i < familyList.length; i++) {
            let family = familyList[i];
            if (!this.isNotNullOrEmpty(family.firstname)) {
              msg += "First Name (Dependent Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(family.fmemname)) {
              msg += "Last Name (Dependent Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(family.middlename)) {
              msg += "Middle Name (Dependent Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(family.relationship)) {
              msg += "Relationship (Dependent Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(family.fbirth)) {
              msg += "Date of Birth (Dependent Details " + (i + 1) + ") is required. </br>";
            } 
          }
        }
      } else if (this.step == '4') {
        let emergencyList = this.record.emergencyList;
        if (emergencyList && emergencyList.length > 0) {
          for (var i = 0; i < emergencyList.length; i++) {
            let emergency = emergencyList[i];
            if (!this.isNotNullOrEmpty(emergency.firstname)) {
              msg += "First Name (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.lastname)) {
              msg += "Last Name (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.middlename)) {
              msg += "Middle Name (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.relationship)) {
              msg += "Relationship (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            }
            if (!this.isNotNullOrEmpty(emergency.addressline)) {
              msg += "Address Line (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.barangay)) {
              msg += "Barangay (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.city)) {
              msg += "City (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.region)) {
              msg += "Region (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.country)) {
              msg += "Country (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.zipcode)) {
              msg += "Zip Code (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.phonetype)) {
              msg += "Phone Type (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.phonenumber)) {
              msg += "Phone Number (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            } 
            if (!this.isNotNullOrEmpty(emergency.personalemailaddress)) {
              msg += "Personal Email Address (Emergency Contact Details " + (i + 1) + ") is required. </br>";
            }
          }
        }
      } else if (this.step == '5') {
        if (!this.isNotNullOrEmpty(this.record.nationality)) {
          msg += "Nationality (Other Personal Details) is required. </br>";
        }
        if (!this.isNotNullOrEmpty(this.record.marstatus)) {
          msg += "Civil Status (Other Personal Details) is required. </br>";
        }
      }
      if (this.isNotNullOrEmpty(msg)) {
        this.$msgDailog.showMsgBox({title: msg});
        return false;
      }
      return true;
    },

    detectDevice() {
      const userAgentInfo = navigator.userAgent;
      const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      const mobileFlag = mobileAgents.some((item) => userAgentInfo.indexOf(item) > 0);
      this.isMobile = mobileFlag;
    },
  },
  mounted() {
    this.detectDevice();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/collectionDialog.vue